var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMappin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.556,
    height: 18.635,
    viewBox: "0 0 13.556 18.635",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#909090;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M206.859,91.971a6.148,6.148,0,0,0-.8-2.271,6.643,6.643,0,0,0-1.484-1.746,6.813,6.813,0,0,0-3.418-1.512,7.009,7.009,0,0,0-2.928.188,6.743,6.743,0,0,0-2.546,1.347,4.044,4.044,0,0,0-.724.735c-.049.015-.073.057-.1.092a6.551,6.551,0,0,0-.623.885,6.194,6.194,0,0,0-.8,2.326,7.386,7.386,0,0,0,.645,4.052,10.042,10.042,0,0,0,1.147,1.805c.437.575.909,1.124,1.367,1.683a4.906,4.906,0,0,0,.554.639q.428.581.857,1.164a8.831,8.831,0,0,1,1.308,2.533,4.227,4.227,0,0,0,.313.809.61.61,0,0,0,1.054,0,2.232,2.232,0,0,0,.2-.5,10.43,10.43,0,0,1,1.862-3.466c.7-.91,1.455-1.775,2.166-2.674a8.518,8.518,0,0,0,1.9-3.836A7.136,7.136,0,0,0,206.859,91.971Zm-8.741-.725a.092.092,0,0,1-.02-.012A.092.092,0,0,0,198.119,91.246Zm3.905,3.335c-.046.046-.088.1-.133.143a4.337,4.337,0,0,1-.732.42,2.678,2.678,0,0,1-2.913-.6,2.418,2.418,0,0,1-.162-3.179,1.157,1.157,0,0,0,.072-.117.062.062,0,0,1-.027,0,.062.062,0,0,0,.027,0,4.266,4.266,0,0,1,.651-.531,2.63,2.63,0,0,1,2.638-.015,2.37,2.37,0,0,1,1.279,1.817A2.324,2.324,0,0,1,202.024,94.582Z",
    transform: "translate(-193.371 -86.367)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMappin);
export default __webpack_public_path__ + "static/media/mappin.c7fba5e09875d78ab1695122fa2f15aa.svg";
export { ForwardRef as ReactComponent };